import React, { useState } from "react";
import { TextField, Button, Grid, Alert } from "@mui/material";
import TranslatedText from "./TranslatedText";

function ContactForm({ addMessageToList }) {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [messageSent, setMessageSent] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const saveToLocalStorage = () => {
    const storedMessages =
      JSON.parse(localStorage.getItem("contactForm")) || [];
    storedMessages.push(formValues);
    localStorage.setItem("contactForm", JSON.stringify(storedMessages));

    // Call the callback function to update the message list in the Contact component
    addMessageToList(formValues);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    saveToLocalStorage();
    setMessageSent(true);
  };

  return (
    <form onSubmit={handleSubmit}>
      {messageSent && (
        <Alert severity="success" onClose={() => setMessageSent(false)}>
          Повідомлення надіслано!
        </Alert>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label={<TranslatedText defaultText="Ім'я" />}
            name="name"
            value={formValues.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label={<TranslatedText defaultText="Електронна пошта" />}
            name="email"
            value={formValues.email}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label={<TranslatedText defaultText="Повідомлення" />}
            name="message"
            value={formValues.message}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            className="contact-btn"
            variant="contained"
            size="medium"
            type="submit"
            style={{
              borderRadius: "25px",
              borderStyle: "double",
              color: "white",
              backgroundColor: "#2875B0",
              position: "relative",
              marginTop: "3%",
            }}
          >
            <TranslatedText defaultText="Надіслати" />
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default ContactForm;
